export default __webpack_public_path__ + "sharp-sans-bold-italic-d367dc4b197517cce4dfbc674e246c37.bundle.woff";